"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageSum = void 0;
const yup_1 = require("@hookform/resolvers/yup");
const header_with_sub_text_1 = require("@pulse-web-ui/header-with-sub-text");
const modal_1 = require("@pulse-web-ui/modal");
const range_input_1 = require("@pulse-web-ui/range-input");
const selector_card_1 = require("@pulse-web-ui/selector-card");
const tooltip_1 = require("@pulse-web-ui/tooltip");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const components_1 = require("./components");
const coverage_sum_styles_1 = require("./coverage-sum.styles");
const coverage_sum_types_1 = require("./coverage-sum.types");
const i18n_1 = require("./i18n");
const CUSTOM_ERROR_TYPE = 'customError';
exports.CoverageSum = (0, react_1.memo)((0, react_1.forwardRef)(({ value, onChange, disabled, options: { min, max, step, activeRisks }, onAnalyticEventSend, formSchema, formContext, isSubmitting, content = {}, fieldState, isIframe, }, ref) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const toggleModal = (0, react_1.useCallback)((isOpen) => () => {
        setIsModalOpen(isOpen);
    }, []);
    const onCloseModal = (0, react_1.useCallback)(() => setIsModalOpen(false), []);
    const { control, trigger, watch, formState: { isValid, errors }, setValue, setError, clearErrors, } = (0, react_hook_form_1.useForm)({
        defaultValues: value,
        resolver: (0, yup_1.yupResolver)(formSchema),
        mode: 'all',
        context: formContext,
    });
    const { coverageSum } = value;
    const coverageSumCustomError = fieldState?.error?.coverageSum?.message;
    const prevCoverageSumRef = (0, react_1.useRef)(coverageSum);
    (0, react_1.useEffect)(() => {
        const isCoverageSumChanged = coverageSum !== prevCoverageSumRef.current;
        if (isCoverageSumChanged) {
            onAnalyticEventSend?.(coverage_sum_types_1.CoverageSumAnalyticEvent.ON_COVERAGE_SUM_CHANGE);
            prevCoverageSumRef.current = coverageSum;
        }
    }, [coverageSum]);
    (0, react_1.useEffect)(() => {
        const subscription = watch((values) => {
            onChange(values);
        });
        return () => subscription.unsubscribe();
    }, [watch, onChange]);
    (0, react_1.useEffect)(() => {
        if (isModalOpen) {
            onAnalyticEventSend?.(coverage_sum_types_1.CoverageSumAnalyticEvent.ON_OPEN_MODAL);
        }
    }, [isModalOpen]);
    (0, react_1.useEffect)(() => {
        if (isSubmitting) {
            trigger();
        }
    }, [isSubmitting]);
    (0, react_1.useEffect)(() => {
        setValue('isValid', isValid);
    }, [isValid]);
    (0, react_1.useEffect)(() => {
        if (coverageSumCustomError) {
            setError('coverageSum', {
                message: coverageSumCustomError,
                type: CUSTOM_ERROR_TYPE,
            });
        }
        else if (errors?.coverageSum?.type === CUSTOM_ERROR_TYPE) {
            clearErrors('coverageSum');
            trigger(['coverageSum']);
        }
    }, [coverageSumCustomError]);
    const ModalContent = content.modal || components_1.InsuranceAmountModalContent;
    return (react_1.default.createElement(coverage_sum_styles_1.Form, { ref: ref },
        !!activeRisks?.length && (react_1.default.createElement("div", null,
            react_1.default.createElement(header_with_sub_text_1.HeaderWithSubText, { title: t('SMART:CoverageSum.title', {
                    defaultValue: i18n_1.i18nDefaultValues.CoverageSum.title,
                }) }),
            react_1.default.createElement(coverage_sum_styles_1.StyledSelectorContainer, null, activeRisks.map(({ name, description, code }) => (react_1.default.createElement(selector_card_1.SelectorCard, { key: code, id: code, label: name, name: "activeRisks", readOnly: true, tooltipOptions: {
                    trigger: tooltip_1.TriggerDirection.HOVER,
                    direction: tooltip_1.TooltipDirection.UP,
                    tooltipText: description,
                } })))))),
        react_1.default.createElement(header_with_sub_text_1.HeaderWithSubText, { title: t('SMART:CoverageSum.coverageTitle', {
                defaultValue: i18n_1.i18nDefaultValues.CoverageSum.coverageTitle,
            }), subTitle: t('SMART:CoverageSum.coverageSubTitle', {
                defaultValue: i18n_1.i18nDefaultValues.CoverageSum.coverageSubTitle,
            }) }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: "coverageSum", render: ({ field, fieldState: { error } }) => (react_1.default.createElement(range_input_1.MoneyRangeInput, { isPriceFormatted: true, readOnly: true, value: field.value ?? 0, min: min, max: max, step: step, onChange: field.onChange, error: !!error || !!coverageSumCustomError, helperErrorText: error?.message || coverageSumCustomError, disabled: disabled })) }),
            react_1.default.createElement(coverage_sum_styles_1.StyledButton, { variant: "text", onClick: toggleModal(true) }, t('SMART:CoverageSum.buttons.howToChooseCoverageSum', {
                defaultValue: i18n_1.i18nDefaultValues.CoverageSum.buttons.howToChooseCoverageSum,
            }))),
        react_1.default.createElement(modal_1.Modal, { desktopWidth: 544, showDialog: isModalOpen, closeIcon: true, submitHandler: onCloseModal, closeHandler: onCloseModal, submitLabel: t('SMART:CoverageSum.buttons.everythingIsClear', {
                defaultValue: i18n_1.i18nDefaultValues.CoverageSum.buttons.everythingIsClear,
            }), dangerouslyBypassScrollLock: isIframe, fullWidthButton: false },
            react_1.default.createElement(ModalContent, null))));
}));
